import Events from 'events';
import DataGUI from '../DataGUI';
import data from '../data';
import keyboard from 'keyboardjs';
import TWEEN from 'tween.js';
import Random from 'random-js';
import Leap from 'leapjs';
const random = Random();

const FIELD_WIDTH = 200;
const FIELD_HEIGHT = 350;

const BLOCK_SIZE = 20;

const SPEED = 4;

import * as names from '../names';

export default class GameScene {
  sounds = {};
  soundsSources = {};
  pyramidLevels = {};
  constructor(options) {
    const {
      rootEl,
      assets,
    } = options;
    this.rootEl = rootEl;
    this.assets = assets;
    this.emitter = new Events();
    this.isBallEnabled = false;
    this.run();
    this.initUi();
  }

  initUi() {
    this.livesAtBegin = 5;
    this.currLives = this.livesAtBegin;
    this.renderLives();
  }
  renderLives() {
    const ui = document.getElementById('gameUi');
    const lives = ui.querySelector('.gameUi__lives');
    let html = '';
    for (let i = 0, len = this.currLives; i < len; i += 1) {
      html += `<div class="gameUi__live"></div>`;
    }
    lives.innerHTML = html;
  }
  deathZone() {
    this.playAudio(names.SOUND_BOOM)
    this.currLives -= 1;
    this.renderLives();
    if (this.currLives === 0) {
      this.isBallEnabled = false;
      this.playAudio(random.pick([names.SOUND_LOSE_VOICE_1, names.SOUND_LOSE_VOICE_2]));
      this.disable();
      this.emitter.emit(names.EVENT_NO_LIVES);
    } else {
      this.ballDx = random.integer(-2,2);
      this.ballDz = -SPEED;
      this.data.ball.position.x = this.data.ball.positionOriginal.x;
      this.data.ball.position.z = this.data.ball.positionOriginal.z;
      this.isBallEnabled = false;
    }
  }
  victory() {
    this.playAudio(names.SOUND_VICTORY_VOICE);
    this.disable();
    this.emitter.emit(names.EVENT_FINAL_BLOCK_KILLED);
  }
  run() {
    this.data = data;
    // this.dataGUI = new DataGUI(data);
    this.onRenderFnArr = [];
    this.init();
    this.initSkyAndBoard();
    this.initBlocks();
    this.initBall();
    this.initAudio();
    this.render();

    const rotationValue = 0.08;
    let tween;
    let from = {y1: 0, y2: 0};

    this.paddleTweenData = {
      delta: 0.4,
      duration: 200,
      minY: this.degToRad(-40),
      maxY:  this.degToRad(40),
    };
    let leapPointBase;
    let leapPoint
    Leap.loop( {background: true}, (frame) => {
      if (frame.pointables.length === 0) {
        if (leapPointBase) {
          this.data.sphere.rotation.y = 0;
          this.data.innerSphere.rotation.y = 0;
          leapPointBase = null;
        }
        return;
      }
      const{minY, maxY} = this.paddleTweenData;
      var appWidth = 2;

      var iBox = frame.interactionBox;
      var pointable = frame.pointables[0];

      var leapPoint = pointable.stabilizedTipPosition;
      if (!leapPointBase) {
        leapPointBase = leapPoint
      }
      var normalizedPoint = iBox.normalizePoint(leapPoint, true);
      var normalizedPointBase = iBox.normalizePoint(leapPointBase, true);

      // var appX = normalizedPoint[0] * appWidth;

      const deltaY = (normalizedPoint[0] - normalizedPointBase[0]) * 2.5;
      const finalDeltaY = (() => {
        if (deltaY > maxY) {
          return maxY;
        } else if (deltaY < minY) {
          return minY;
        }
        return deltaY;
      })();
      this.data.sphere.rotation.y = -finalDeltaY;
      this.data.innerSphere.rotation.y = finalDeltaY;

      // console.log(normalizedPoint[1], normalizedPoint[1] == 0);
      if (normalizedPoint[1] == 0) {
        if (this.currLives > 0) {
          this.isBallEnabled = true;
        }
      }
    }).connect();
    //
    // this.isRightPressed = true;
    // this.moveRight();

    keyboard.bind('up', (e) => {
      if (this.currLives > 0) {
        this.isBallEnabled = true;
      }
    });

    keyboard.bind('left', (e) => {
      e.preventRepeat();
      this.isLeftPressed = true;
      this.moveLeft();
      // this.data.block.position.x -= 30;
      // this.data.sphere.rotation.y += rotationValue;
      // this.data.innerSphere.rotation.y -= rotationValue;


    }, () => {
      this.isLeftPressed = false;
      this.paddleTween.stop();
      // tween.stop();
    });

    keyboard.bind('left + right', (e) => {
      e.preventRepeat();
      this.isLeftPressed = false;
      this.isRightPressed = false;
    });

    keyboard.bind('right', (e) => {
      e.preventRepeat();
      this.isRightPressed = true;
      this.moveRight();
      // this.data.block.position.x += 30;
      // this.data.sphere.rotation.y -= rotationValue;
      // this.data.innerSphere.rotation.y += rotationValue;


    }, () => {
      this.isRightPressed = false;
      this.paddleTween.stop();
      // tween.stop();
    });

    keyboard.bind('space', () => {
      // this.blocksGroupRotationY += Math.PI / 12;
      // this.blocksGroupRotationY += Math.PI / 3;
      this.rotatePyramid();
    });
  }

  moveLeft() {
    const {
      delta,
      duration,
      minY,
      maxY,
    } = this.paddleTweenData;
    let tween = this.paddleTween;
    if (tween) {
      // tween.stop();
    }
    const from = {};

    from.y1 = this.data.sphere.rotation.y;
    from.y2 = this.data.innerSphere.rotation.y;



    let newY1 = this.data.sphere.rotation.y + delta;
    // newY1 = newY1 > maxY ? maxY : newY1;
    let newY2 = this.data.innerSphere.rotation.y - delta;
    // newY2 = newY2 < minY ? minY : newY2;
    tween = new TWEEN.Tween(from).to({
      y1: newY1,
      y2: newY2,
    }, duration);
    // tween.easing(TWEEN.Easing.Quadratic.In);

    tween.onUpdate(() => {
      this.data.sphere.rotation.y = from.y1 > maxY ? maxY : from.y1;
      this.data.innerSphere.rotation.y = from.y2 < minY ? minY : from.y2;
    });
    tween.onComplete(() => {
      if (this.isLeftPressed) {
        this.moveLeft();
      }
    });
    tween.start();
    this.paddleTween = tween;
  }
  moveRight() {
    const {
      delta,
      duration,
      minY,
      maxY,
    } = this.paddleTweenData;
    let tween = this.paddleTween;
    if (tween) {
      // tween.stop();
    }
    const from = {};

    from.y1 = this.data.sphere.rotation.y;
    from.y2 = this.data.innerSphere.rotation.y;




    let newY1 = this.data.sphere.rotation.y - delta;
    // newY1 = newY1 < minY ? minY : newY1;
    let newY2 = this.data.innerSphere.rotation.y + delta;
    // newY2 = newY2 > maxY ? maxY : newY2;
    tween = new TWEEN.Tween(from).to({
      y1: newY1,
      y2: newY2,
    }, duration);

    tween.onUpdate(() => {
      this.data.sphere.rotation.y = from.y1 < minY ? minY : from.y1;
      this.data.innerSphere.rotation.y = from.y2 > maxY ? maxY : from.y2;
    });

    tween.onComplete(() => {
      if (this.isRightPressed) {
        this.moveRight();
      }
    });
    tween.start();
    this.paddleTween = tween;
  }

  rotatePyramid() {
    const rad2deg = 180/Math.PI;

    if (this.pyramidTween) {
      this.pyramidTween.stop();
    }
    const from = {
      y: this.blocksGroupRotationY,
    };
    const tween = new TWEEN.Tween(from).to({
      y: this.getRadForPyramid(),
    }, 300);

    tween.onUpdate(() => {
      this.blocksGroupRotationY = from.y;
    });
    tween.start();
  }

  getRadForPyramid() {
    const rad = this.blocksGroupRotationY;
    const deg = rad * 180/Math.PI;
    const inc = (Math.random() > 0.5 ? 1 : -1) * 90;
    const newDeg = parseInt((deg + inc) / 90) * 90;
    const newRad = newDeg * Math.PI/180;;
    // console.log(rad, deg, newDeg, newRad)
    return newRad;
  }

  degToRad(deg) {
    return deg * Math.PI/180;
  }
  radToDeg(rad) {
    return rad * 180 / Math.PI;
  }


  initAudio() {
    // this.playAudio(SOUND_GAME_MUSIC, true);
  }

  playAudio(soundName, isLoop = false) {
    this.assets.getSound(soundName).loop = isLoop;
    this.assets.getSound(soundName).play();
  }

  init() {
    const scene = new THREE.Scene();

    const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 10000);
    camera.position.y = this.data.camera.position.y;
    camera.position.z = this.data.camera.position.z;
    camera.position.x = this.data.camera.position.x;
    this.onRenderFnArr.push(() => {
      camera.position.y = this.data.camera.position.y;
      camera.position.z = this.data.camera.position.z;
      camera.position.x = this.data.camera.position.x;
    });
    scene.add(camera);

    const renderer = new THREE.WebGLRenderer({ antialias: true }); // Initialize renderer + anti-alias
    renderer.shadowMapEnabled = renderer.shadowMapSoft = true; // Enable shadows and make them smoother
    renderer.setSize(window.innerWidth, window.innerHeight); // Set the size to the whole window
    renderer.sortObjects = false; // Improves performance


    this.rootEl.appendChild(renderer.domElement); // Put the canvas onto the page

    this.scene = scene;
    this.camera = camera;
    this.renderer = renderer;
  }


  initSkyAndBoard() {
    const {scene, renderer, camera} = this;
    // Lights
    [-200, 200].forEach(function (distance) {
      return;
      const light = new THREE.DirectionalLight(0xffffff, 1);
      light.position.set(distance, 200, 500);
      scene.add(light);

    });


    const light = new THREE.SpotLight(0xffffff, 1);
    light.position.set(0, 350, 500);
    light.shadowCameraNear = 0.01;
    light.castShadow = true;
    light.shadowDarkness = 0.3;
    light.shadowMapWidth = light.shadowMapHeight = 2048; // Larger shadow map improves shadow quality
    scene.add(light);


    // Sky
    let geometry = new THREE.PlaneGeometry(3500, 1500);
    let material = new THREE.MeshBasicMaterial();
    const sky = new THREE.Mesh(geometry, material);

    sky.position.set(0, -500, -800);
    sky.rotation.set(-900, 0, 0);
    // scene.add(sky);


    // Board
    geometry = new THREE.CubeGeometry(FIELD_WIDTH, 3, FIELD_HEIGHT);
    material = new THREE.MeshBasicMaterial();
    const board = new THREE.Mesh(geometry, material);

    board.matrixAutoUpdate = false; // The board will be static, so no need to update it
    board.receiveShadow = true; // It can receive shadows
    // scene.add(board);
    // camera.lookAt(board.position);

    // geometry
    let radius = 5;
    geometry = new THREE.SphereGeometry( radius, 16, 8 );

    // material
    material = new THREE.MeshBasicMaterial( {
      color: 0xffffff,
      wireframe: true
    } );

    // mesh
    // let mesh = new THREE.Mesh( geometry, material );
    let mesh = new THREE.Object3D();
    scene.add( mesh );
    mesh.add(board);

    this.sphere = mesh;

    const innerSphere = new THREE.Object3D();
    this.sphere.add(innerSphere);
    this.innerSphere = innerSphere;

    this.onRenderFnArr.push(() => {
      this.sphere.rotation.x = this.data.sphere.rotation.x;
      this.sphere.rotation.y = this.data.sphere.rotation.y;

      this.innerSphere.rotation.x = this.data.innerSphere.rotation.x;
      this.innerSphere.rotation.y = this.data.innerSphere.rotation.y;
    });

  }

  initBlocksPaddle() {
    const size = 15;
    let geometry;
      geometry = new THREE.CubeGeometry(size*4, size * 0.5, size);
    const material = new THREE.MeshLambertMaterial({ color: 0x949ba1 });
    const mesh = new THREE.Mesh(geometry, material);
    const bBox = new THREE.BoundingBoxHelper(mesh, 0x00ff00);
    bBox.update();
    bBox.visible = false;
    mesh.isPaddle = true;
    this.innerSphere.add(mesh);
    this.onRenderFnArr.push(() => {
      mesh.position.set(this.data.block.position.x, this.data.block.position.y, FIELD_HEIGHT/2);
      bBox.update();

      if (bBox.box.intersectsBox(this.ballBox.box)) {


        const x1 = this.data.ball.position.x;
        const z1 = this.data.ball.position.z;

        const x2 = x1 + this.ballDx;
        const z2 = z1 + this.ballDz;

        var deg2rad = Math.PI/180;
        var rad2deg = 180/Math.PI;

        const tan = (x2 - x1)/(z2-z1);
        const ballAngle   = Math.atan(tan * rad2deg);
        const paddleAngle = Math.atan(this.innerSphere.rotation.y * rad2deg);

        const newBallAngle = ballAngle;


        this.playAudio(names.SOUND_INTERSECT_PADDLE);
        // console.log(this.ball.position.x, this.ball.position.z, bBox.position.x, bBox.position.z, this.innerSphere.rotation.y);
        // this.ballDz = -this.ballDz;
        this.ballDz = this.ballDz < 0
          ? random.integer(SPEED, SPEED+3)
          : -random.integer(SPEED, SPEED+3);
        if (random.bool(0.1)) {
          this.ballDz = this.ballDz < 0 ? this.ballDz - 1 : this.ballDz + 1;
        }
        // this.ballDx = -this.ballDx;
        // this.ballDx = -1*2*(mesh.position.x-this.ball.position.x)/10;

        const prevDx = this.ballDx;
        const prevDz = this.ballDz;
        const newDx = -random.integer(SPEED, SPEED + 4) * Math.cos(newBallAngle + (random.pick([0, -Math.PI/8])));
        // const newDz = -random.integer(SPEED, SPEED + 4) * Math.sin(newBallAngle);
        this.ballDx = newDx;
        // this.ballDz = newDz;

        // console.log('boom',
        //   [prevDx.toFixed(2), prevDz.toFixed(2)],
        //   [newDx.toFixed(2), newDz.toFixed(2)],
        //   paddleAngle.toFixed(2),
        //   ballAngle.toFixed(2),
        //   newBallAngle.toFixed(2),
        // );

        // this.paused = true;
      }
    });

    this.paddle = {
      mesh: mesh,
      box: bBox,
    }
  }

  changePyramidBlocksYPositionIfNeeded() {
    const {pyramidLevels} = this;
    Object.keys(pyramidLevels).forEach(levelNum => {
      const level = pyramidLevels[levelNum];
      const {isCompleted, blocks} = level;
      if (!isCompleted) {
        let atLeastOneVisible = false;
        for (let i = 0, len = blocks.length; i < len; i += 1) {
          if (blocks[i].visible) {
            atLeastOneVisible = true;
            break;
          }
        }
        if (!atLeastOneVisible) {
          level.isCompleted = true;
          this.changePyramidBlocksYPosition();
        }
      }
    })
  }

  changePyramidBlocksYPosition() {
    const {pyramidLevels} = this;
    Object.keys(pyramidLevels).forEach(levelNum => {
      const level = pyramidLevels[levelNum];
      const {isCompleted, blocks, currLevel} = level;
      blocks.forEach(mesh => {
        const from = {
          y: this.getBlockOffset(currLevel ),
        }
        const tween = new TWEEN.Tween(from).to({
          y: this.getBlockOffset(currLevel - 1)
        }, 300);

        // console.log(from);

        tween.onUpdate(() => {
          mesh.position.y = from.y;
        });
        tween.start();
        level.currLevel -= 1;
      });
    });

  }



  initBlocksBlocks() {
    const size = BLOCK_SIZE;
    const blocksGroup = new THREE.Object3D();
    const blocksGroupPivot = new THREE.Object3D();
    blocksGroupPivot.position.z = -FIELD_HEIGHT/2 + 100;
    blocksGroupPivot.add(blocksGroup);

    this.sphere.add(blocksGroupPivot);
    this.blocksGroupRotationY = 0;
    this.onRenderFnArr.push(() => {
      blocksGroupPivot.rotation.y = this.blocksGroupRotationY;
    });

    const createBlock = (x, y, z, level, isEdge, isFinalBlock ) => {
      const geometry = new THREE.CubeGeometry(size, size, size );
      const material = new THREE.MeshLambertMaterial({
        color: isFinalBlock ? 0xeeeeee :
          isEdge ? 0xffffff : 0x949ba1
      });
      const mesh = new THREE.Mesh(geometry, material);
      const bBox = new THREE.BoundingBoxHelper(mesh, 0x00ff00)
      if (!this.pyramidLevels[level]) {
          this.pyramidLevels[level] = {
            isCompleted: false,
            blocks: [],
            currLevel: level,
            isEdge: true,
          }
      }
      this.pyramidLevels[level].blocks.push(mesh);
      bBox.update();
      bBox.visible = false;
      blocksGroup.add(mesh);
      mesh.position.set(x, y, z);
      this.onRenderFnArr.push(() => {
        bBox.update();

        if (bBox.box.intersectsBox(this.ballBox.box)) {
          if (mesh.visible) {
            this.data.ball.position.x += this.ballDx;
            this.data.ball.position.z += this.ballDz;

            this.ballDz = -this.ballDz;
            this.ballDx = -this.ballDx;
            mesh.visible = false;
            this.playAudio(random.pick([
              names.SOUND_INTERSECT_CUBE_1,
              names.SOUND_INTERSECT_CUBE_2,
              names.SOUND_INTERSECT_CUBE_3,
            ]));
            // Math.random() > 0.5 && this.rotatePyramid();
            if (isEdge) {
              this.rotatePyramid();
            }
            this.changePyramidBlocksYPositionIfNeeded();
            if (isFinalBlock) {
              this.victory();
            }
          }
        }
      });

      return {mesh, bBox};
    }

    /**
     *
     *                x->
     * a a a a a a a
     * a B B B B B a
     * a B c c c B a
     * a B c D c B a
     * a B c c c B a
     * a B B B B B a
     * a a a a a a a
     *
     * z V
     */

    const offset = size/3;
    const length = 5;

    blocksGroup.position.x -= size * length / 2 + size/2;
    blocksGroup.position.z -= size * length / 2 + size/2;

    for (var yIndex = 0; yIndex <= parseInt(length / 2); yIndex += 1) {
      const y = size/2 + yIndex * (size + offset);

      for (var zIndex = yIndex; zIndex < length - yIndex; zIndex += 1) {
        const z = zIndex * (size + offset);

        for (var xIndex = yIndex; xIndex < length - yIndex; xIndex += 1) {
          const x = xIndex * (size + offset);

          const isEdge = (
            (xIndex === yIndex && zIndex === yIndex) ||
            (xIndex === length - yIndex - 1 && zIndex === yIndex) ||
            (xIndex === yIndex && zIndex === length - yIndex - 1) ||
            (xIndex === length - yIndex - 1 && zIndex === length - yIndex - 1)
          );
          const isFinal = yIndex === parseInt(length / 2);
          createBlock(
            x,y,z, yIndex, isEdge ? isEdge : random.bool(0.2), isFinal
          );
        }
      }
    }
  }

  getBlockOffset(yIndex) {
    const size = BLOCK_SIZE;
    const offset = size/3;
    return size/2 + (yIndex) * (size + offset);
  }


  initBlocks() {
    this.initBlocksPaddle();
    this.initBlocksBlocks();
  }

  initBall() {
    const size = 10;
    const geometry = new THREE.SphereGeometry(size/2);
    const material = new THREE.MeshLambertMaterial({ color: 0x949ba1 });
    const mesh = new THREE.Mesh(geometry, material);
    const bBox = new THREE.BoundingBoxHelper(mesh, 0x00ff00);
    bBox.update();
    bBox.visible = false;

    mesh.position.set(this.data.ball.position.x, this.data.ball.position.y, this.data.ball.position.z);
    bBox.update()
    this.sphere.add(mesh);
    this.ballDx = random.integer(-2,2);
    this.ballDz = -SPEED;
    this.onRenderFnArr.push(() => {
      if (this.isBallEnabled) {
        this.data.ball.position.x += this.ballDx;
        this.data.ball.position.z += this.ballDz;
        if (this.data.ball.position.x > FIELD_WIDTH/2) {
          this.ballDx = -Math.abs(this.ballDx);
        }
        if (this.data.ball.position.x < -FIELD_WIDTH/2) {
          this.ballDx = Math.abs(this.ballDx);
        }
        if (this.data.ball.position.z > FIELD_HEIGHT/2) {
          this.deathZone();
          this.ballDz = -Math.abs(this.ballDz);
        }
        if (this.data.ball.position.z < -FIELD_HEIGHT/2) {
          this.ballDz = Math.abs(this.ballDz);
        }
        mesh.position.set(this.data.ball.position.x, this.data.ball.position.y, this.data.ball.position.z);
        bBox.update();
      }
    });

    setTimeout(() => {
      if (!this.isBallEnabled && (this.currLives === this.livesAtBegin)) {
        this.isBallEnabled = true;
      }
    }, 8000);


    this.ball = mesh;
    this.ballBox = bBox;
  }

  render = () => {
    if (this.paused) {
      return;
    }
     // console.log(
     //   (this.innerSphere.rotation.y* 180/Math.PI) % 360,
     //   this.innerSphere.rotation.y* Math.PI / 180,
     //   Math.atan(this.innerSphere.rotation.y) * 180/Math.PI,
     // );
    const {render, renderer, scene, camera, onRenderFnArr} = this;
    onRenderFnArr.forEach(fn => fn());

    // Render the current frame
    renderer.render(scene, camera);

    requestAnimationFrame(render);
    TWEEN.update();
  }

  enable() {
    this.paused = false;
    this.render();
  }

  disable() {
    this.paused = true;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scenes/GameScene.js
 **/